import { render, staticRenderFns } from "./TagsView.vue?vue&type=template&id=43c3bb28&scoped=true"
import script from "./TagsView.vue?vue&type=script&lang=js"
export * from "./TagsView.vue?vue&type=script&lang=js"
import style0 from "./TagsView.vue?vue&type=style&index=0&id=43c3bb28&prod&lang=scss&scoped=true"
import style1 from "./TagsView.vue?vue&type=style&index=1&id=43c3bb28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c3bb28",
  null
  
)

export default component.exports